// ##############################
// // // Notifications view styles
// #############################

import { defaultFont } from "assets/jss/material-dashboard-pro-react.jsx";
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";

const notificationsStyle = theme => ({
  cardTitle: {
    marginTop: "0",
    paddingBottom: "8px",
    color: "#020303",
    fontSize: "17px"
  },
  notificationCardBody: {
    flex: '1 1 auto',
    padding: '0px 20px',
    position: 'relative',
    '-webkit-box-flex': '1',
    top: '-15px',
    transition: 'width 0.5s 0.5s, height 0.5s 0.5s, opacity 0.5s'
  },
  cardHeader: {
    zIndex: "3"
  },
  cardSubtitle: {
    ...defaultFont,
    color: "#999999",
    fontSize: "14px",
    margin: "0 0 10px"
  },
  notificationType: {
  color: 'rgb(14, 178, 216)',
  paddingBottom: '8px',
  fontWeight: '900',
  fontSize: '25px',
  textTransform: 'capitalize'
  },
  // timeStamp: {

  // },
  center: {
    textAlign: "center"
  },
  right: {
    textAlign: "right"
  },
  left: {
    textAlign: "left"
  },
  marginRight: {
    marginRight: "5px"
  },
  closingX: {
  alignSelf: 'flex-end',
  paddingTop: '20px',
  '&:hover': {
    color: '#FC6047',
    cursor: 'pointer'
  }
  },
  mainNotificationDiv: {
  [theme.breakpoints.down("sm")]: {
    marginBottom: '20%'
  }
  },
  modalSectionTitle: {
    marginTop: "30px"
  },
  ...modalStyle(theme)
});

export default notificationsStyle;
